export const saveOrUpdate = '/icps/system/sign/basics/factors/saveOrUpdate'
import request from '@/utils/request'

export function getFactorsPreList(data) {
  return request({
    url: '/icps/system/sign/basics/factorsPre/getFactorsPreList',
    method: 'post',
    data
  })
}
export function saveOrUpdatePost(data) {
  return request({
    url: '/icps/system/sign/basics/factors/saveOrUpdate',
    method: 'post',
    data
  })
}
export function queryFactorWeight(data) {
  return request({
    url: '/icps/system/sign/basics/factors/queryFactorWeight',
    method: 'post',
    data
  })
}
export function saveOrUpdateWeight(data) {
  return request({
    url: '/icps/system/sign/basics/factors/saveOrUpdateWeight',
    method: 'post',
    data
  })
}